import { render } from "./PaymentHistoryDialog.vue?vue&type=template&id=b496e862&scoped=true"
import script from "./PaymentHistoryDialog.vue?vue&type=script&lang=js"
export * from "./PaymentHistoryDialog.vue?vue&type=script&lang=js"

import "./PaymentHistoryDialog.vue?vue&type=style&index=0&id=b496e862&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b496e862"]])

export default __exports__